<template>
  <div id="dialog-customerTagEdit">
    <div class="dialog">
      <span class="cls" @click="tagEditSwitch(false)"></span>
      <div class="paper">
        <div class="header"> <h1>고객정보수정</h1> <span @click="tagEditSwitch(false)"><i class="ph-bold ph-x"></i></span> </div>
        <div class="content">
          <ul>
            <template v-for="tag in tagList" :key="tag.idx">
              <li>
                <div> {{ tag.name }} </div>
                <button @click="delTag(tag)"><i class="ph-fill ph-x-circle"></i></button>
              </li>
            </template>
          </ul>
        </div>
        <div class="add-section">
          <input type="text" placeholder="새 그룹 입력" v-model="newTagName" @keyup.enter="addTag" />
        </div>
        <div class="btns">
          <button class="btn btn-cancel" @click="tagEditSwitch(false)">취소</button>
          <button class="btn btn-primary" @click="addTag">확인</button>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
import { inject, ref } from "vue";
import { useBackButton } from '@/utils/useBackBtn';

export default {
  props: {
    tagEditSwitch: {
      type: Function,
      required: true
    },
    reloadTagList: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const sql_query = inject('sql_query');
    const getMbid = inject('getMbid');
    const newTagName = ref('');

    const tagList = ref([]);

    let maxTagCnt = 8;

    useBackButton(() => {
      props.tagEditSwitch(false);
    });
    
    async function fetchTagList() {
      let sql = `SELECT * FROM customer_tag WHERE mb_id = '${getMbid()}'`;
      let result = await sql_query(sql);
      tagList.value = result;
    }
    fetchTagList();

    async function addTag() {
      if (!newTagName.value.trim()) {
        alert('태그 이름을 입력해주세요.');
        return;
      }
      if (tagList.value.length >= maxTagCnt) {
        alert(`태그는 최대 ${maxTagCnt}개까지만 추가할 수 있습니다.`);
        return;
      }
      let sql = `INSERT INTO customer_tag set name = '${newTagName.value.trim()}', mb_id = '${getMbid()}'`;
      await sql_query(sql);
      fetchTagList();
      newTagName.value = '';
      props.reloadTagList()
    }

    async function delTag(tag) {
      let ask = confirm(`태그 ${tag.name}을(를) 삭제하시겠습니까?`);
      if (!ask) return;

      try {
        // 1) customer_tag 테이블에서 삭제 (prepared statement 방식)
        let sql = `DELETE FROM customer_tag WHERE idx = '${tag.idx}'`;
        await sql_query(sql);

        // 2) customers 테이블의 tags JSON에서 해당 태그 이름 제거
        let sql2 = ` UPDATE customers SET tags = CASE 
            WHEN JSON_SEARCH(tags, 'one', '${tag.name}') IS NOT NULL 
            THEN JSON_REMOVE(tags, JSON_UNQUOTE(JSON_SEARCH(tags, 'one', '${tag.name}')))
            ELSE tags
          END
          WHERE mb_id = '${getMbid()}'
        `;
        await sql_query(sql2);

        // 3) UI 갱신
        fetchTagList();
        props.reloadTagList();
        
      } catch (error) {
        console.error('태그 삭제 실패:', error);
        alert('태그 삭제 중 오류가 발생했습니다.');
      }
    }


    return {
      tagList,
      newTagName,
      addTag,
      delTag,
    }
  }
}
</script>


<style scoped>
#dialog-customerTagEdit {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
}

.dialog {
  position: absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  background: var(--color-surface);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  backdrop-filter: blur(2px);
}
.cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.dialog > .paper {
  width: 90%;
  max-width:600px;
  height:40%;
  background: var(--color-background);
  border:1px solid var(--color-background-light);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  gap:16px;
  display:flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  width:100%;
  height:48px;
  display:flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-lg);
}

.header > h1 {
  font-size:20px;
}

.header > span {
  width:48px;
  height:48px;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
}

.content {
  flex:1;
  width:100%;
  overflow-y: auto;
}

.content > ul {
  width:100%;
  display:flex;
  flex-wrap: wrap;
  gap:12px;
  padding:0;
  margin:0;
  list-style: none;
}

.content > ul > li {
  width:fit-content;
  height: fit-content;
  padding:6px 12px;
  border-radius: 100px;
  background: var(--color-background-light);
  display: flex;
  align-items: center;
  gap:6px;
}

.content > ul > li > button {
  width:24px;
  height:24px;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
  font-size:20px;
  background:none;
  border:none;
}

.content > ul > li > button > i {
  font-size:20px;
  color: var(--color-text-primary);
  opacity: 0.8;
}

.add-section {
  width:100%;
  height:48px;
  display:flex;
  align-items: center;
}

.add-section > input {
  width:100%;
  height:100%;
  padding:0 16px;
  background: var(--color-background-light);
  border:none;
  border-radius: 8px;
  font-size: var(--font-size-base);
}

.add-section > input::placeholder {
  color: var(--color-text-primary);
  opacity: 0.4;
}

.add-section > input:focus {
  outline: 2px solid var(--color-brand);
}

.btns {
  width:100%;
  height:40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap:12px;
}

.btns > button {
  width: 100%;
  height: 100%;
  padding: 0 16px;
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--color-text-primary);
  background: var(--color-background-light);
  border:none;
  border-radius: 8px;
  cursor: pointer;
}

.btns > button.btn-primary {
  background: var(--color-brand);
  color: var(--color-text-black);
}

.btns > button.btn-cancel {
  background: var(--color-background-light);
  color: var(--color-text-primary);
}
</style>